interface UrlParams {
  parentId: number;
  parentType: string;
  programId: number | string;
}

export const getProgramIndexUrl = ({
  parentType,
  parentId,
  programId,
}: UrlParams) =>
  parentType === 'Network'
    ? Routes.spa_mentoring_program_index_path(programId)
    : Routes.topic_spa_mentoring_program_index_path(parentId, programId);

export const getApplyToBeMentorUrl = ({
  parentType,
  parentId,
  programId,
}: UrlParams) =>
  parentType === 'Network'
    ? Routes.spa_mentoring_program_apply_mentor_path(programId)
    : Routes.topic_spa_mentoring_program_apply_mentor_path(parentId, programId);

export const getApplyToBeMenteeUrl = ({
  parentType,
  parentId,
  programId,
}: UrlParams) =>
  parentType === 'Network'
    ? Routes.spa_mentoring_program_apply_mentee_admin_match_path(programId)
    : Routes.topic_spa_mentoring_program_apply_mentee_admin_match_path(
        parentId,
        programId,
      );
